import { useDispatch } from "react-redux";
import ComponentCard from "../../components/common/ComponentCard";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import UserListComponent from "../../components/user/UserListComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import React, { useEffect } from "react";
import { fetchUsersStart } from "../../slices/userSlice";

export default function UserList() {
    return (
        <>
            {/*<PageMeta*/}
            {/*    title="React.js Basic Tables Dashboard | TailAdmin - Next.js Admin Dashboard Template"*/}
            {/*    description="This is React.js Basic Tables Dashboard page for TailAdmin - React.js Tailwind CSS Admin Dashboard Template"*/}
            {/*/>*/}
            {/*<PageBreadcrumb pageTitle="Người dùng" />*/}
            <PageMeta title="Danh sách người dùng" description="Trang danh sách người dùng"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <UserListComponent />
                </ComponentCard>
            </div>
        </>
    );
}
